export const actionTypes: any = {
  // get cms categories
  GET_CMS_CATEGORIES_START: 'GET_CMS_CATEGORIES_START',
  GET_CMS_CATEGORIES_SUCCESS: 'GET_CMS_CATEGORIES_SUCCESS',
  GET_CMS_CATEGORIES_FINISH: 'GET_CMS_CATEGORIES_FINISH',
  // get cms categories
  GET_SPECIFIC_CMS_CATEGORIES_START: 'GET_SPECIFIC_CMS_CATEGORIES_START',
  GET_SPECIFIC_CMS_CATEGORIES_SUCCESS: 'GET_SPECIFIC_CMS_CATEGORIES_SUCCESS',
  GET_SPECIFIC_CMS_CATEGORIES_FINISH: 'GET_SPECIFIC_CMS_CATEGORIES_FINISH',

  // get form download categories
  GET_FORM_DOWNLOAD_CATEGORIES_START: 'GET_FORM_DOWNLOAD_CATEGORIES_START',
  GET_FORM_DOWNLOAD_CATEGORIES_SUCCESS: 'GET_FORM_DOWNLOAD_CATEGORIES_SUCCESS',
  GET_FORM_DOWNLOAD_CATEGORIES_FINISH: 'GET_FORM_DOWNLOAD_CATEGORIES_FINISH',

  // ADD cms categories
  ADD_CMS_CATEGORIES_START: 'ADD_CMS_CATEGORIES_START',
  ADD_CMS_CATEGORIES_SUCCESS: 'ADD_CMS_CATEGORIES_SUCCESS',
  ADD_CMS_CATEGORIES_FINISH: 'ADD_CMS_CATEGORIES_FINISH',
  ADD_CMS_CATEGORIES_RESET: 'ADD_CMS_CATEGORIES_RESET',

  // Update cms categories
  UPDATE_CMS_CATEGORIES_START: 'UPDATE_CMS_CATEGORIES_START',
  UPDATE_CMS_CATEGORIES_SUCCESS: 'UPDATE_CMS_CATEGORIES_SUCCESS',
  UPDATE_CMS_CATEGORIES_FINISH: 'UPDATE_CMS_CATEGORIES_FINISH',
  UPDATE_CMS_CATEGORIES_RESET: 'UPDATE_CMS_CATEGORIES_RESET',

  // delete cms categories
  DELETE_CMS_CATEGORIES_START: 'DELETE_CMS_CATEGORIES_START',
  DELETE_CMS_CATEGORIES_SUCCESS: 'DELETE_CMS_CATEGORIES_SUCCESS',
  DELETE_CMS_CATEGORIES_FINISH: 'DELETE_CMS_CATEGORIES_FINISH',

  // single active cms categories
  SINGLE_ACTIVATE_CMS_CATEGORIES_REQUEST: 'SINGLE_ACTIVATE_CMS_CATEGORIES_REQUEST',
  SINGLE_ACTIVATE_CMS_CATEGORIES_SUCCESS: 'SINGLE_ACTIVATE_CMS_CATEGORIES_SUCCESS',
  SINGLE_ACTIVATE_CMS_CATEGORIES_FINISH: 'SINGLE_ACTIVATE_CMS_CATEGORIES_FINISH',

  // single deactive cms categories
  SINGLE_DEACTIVATE_CMS_CATEGORIES_REQUEST: 'SINGLE_DEACTIVATE_CMS_CATEGORIES_REQUEST',
  SINGLE_DEACTIVATE_CMS_CATEGORIES_SUCCESS: 'SINGLE_DEACTIVATE_CMS_CATEGORIES_SUCCESS',
  SINGLE_DEACTIVATE_CMS_CATEGORIES_FINISH: 'SINGLE_DEACTIVATE_CMS_CATEGORIES_FINISH',

  // sort categories
  SORT_CATEGORIES_START: 'SORT_CATEGORIES_START',
  SORT_CATEGORIES_SUCCESS: 'SORT_CATEGORIES_SUCCESS',
  SORT_CATEGORIES_FINISH: 'SORT_CATEGORIES_FINISH',
  SORT_CATEGORIES_RESET: 'SORT_CATEGORIES_RESET',
}
